import { AnchorHTMLAttributes, MouseEvent, ReactNode } from 'react';

import {
  FontIconNamesUnion,
  GhostLinkStoryblok,
  Locales,
} from '@monoimin/sb-types';

import { SharedLinkProps } from '../link/SharedLink';

export const buttonClasses = {
  primary: 'button-primary',
  secondary: 'button-secondary',
  none: '',
};

export type ButtonVariant = keyof typeof buttonClasses;
export type ButtonSize = 'small' | 'table' | 'default';

export interface UIButtonProps {
  icon?: FontIconNamesUnion | undefined;
  variant?: ButtonVariant;
  className?: string;
  iconClassName?: string;
  children?: ReactNode | undefined;
  size?: ButtonSize;
  theme?: 'dark' | 'blue' | 'default' | 'light';
}

export interface LinkButtonProps extends UIButtonProps {
  href: string;
  fullSizeOverlay?: SharedLinkProps['fullSizeOverlay'];
  target?: AnchorHTMLAttributes<HTMLAnchorElement>['target'];
  'data-testid'?: string;
}

export interface GhostLinkProps
  extends Omit<UIButtonProps, 'variant' | 'size' | 'theme'> {
  href: string;
  fullSizeOverlay?: SharedLinkProps['fullSizeOverlay'];
  target?: AnchorHTMLAttributes<HTMLAnchorElement>['target'];
  iconPosition?: 'left' | 'right';
  theme?: GhostLinkStoryblok['theme'];
  animate?: boolean;
}
export interface UIGhostLinkProps
  extends Omit<UIButtonProps, 'variant' | 'size' | 'theme'> {
  iconPosition?: 'left' | 'right';
  theme?: GhostLinkStoryblok['theme'];
  animate?: boolean;
}

export interface FormButtonProps
  extends Omit<UIButtonProps, 'icon' | 'iconClassName'> {
  type?: 'submit' | 'reset' | 'button';
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  dataTestId?: string;
  loading?: boolean;
  disabled?: boolean;
  locale?: Locales;
}
